import { createPinia } from "pinia";
import { PiniaColada } from "@pinia/colada";
import type { Plugin } from "vue";

export default {
  install(app) {
    app.use(createPinia());
    app.use(PiniaColada, {});
  },
} as Plugin;
